<template>
  <header
    :class="{
      scrolled: isScrolled,
      white: this.color === 'white',
      black: this.color === 'black',
    }"
  >
    <div class="container" :class="{ navopen: mainNavVisible == true }">
      <a href="/" class="site__logo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 228.44 50.77">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path
                class="cls-1"
                d="M10.25,22.21H0V42.69A21.38,21.38,0,0,0,20.48,22.21H10.25ZM83.72,42.67h7.16V19.13H83.72Zm3.47-32.52a4,4,0,1,0,4.09,4A4.06,4.06,0,0,0,87.19,10.15Zm-65,10.35H42.71V0A21.38,21.38,0,0,0,22.22,20.5Zm201.86,14a4.21,4.21,0,0,0-4.36,4.31,4.36,4.36,0,1,0,8.72,0A4.21,4.21,0,0,0,224.08,34.53ZM75.45,24.67l-3.86-1.49c-2.09-.79-2.81-1.67-2.81-2.95a2.25,2.25,0,0,1,2.54-2.29c1.73,0,2.71,1.32,2.67,3.21h6.84c.31-5.41-2.31-9.5-9.56-9.5-6,0-9.91,3.7-9.91,9a8.77,8.77,0,0,0,4.76,8.27c1.69.84,3.24,1.41,4.8,2,2,.75,3.24,1.58,3.24,3.3A2.61,2.61,0,0,1,71.23,37c-2.45,0-3.2-1.89-3.11-3.83h-7c-.26,4.45,1.34,10.12,10.14,10.12,6.18,0,10.58-3.6,10.58-9.76C81.81,28.94,79.46,26.3,75.45,24.67Zm114-5.8a6.53,6.53,0,0,0-4.8,1.76v-1.5h-7.16V42.67h7.16V28c0-1.71.89-2.81,2.54-2.81s2.53,1.14,2.53,2.86V42.67h7.16V27.18C196.83,22.65,195,18.87,189.4,18.87Zm-22.14,23.8h7.43V12.22h-7.43Zm43.57-17.56a5.89,5.89,0,0,1,4,1.54l4-5a11.5,11.5,0,0,0-8-2.91A12,12,0,0,0,198.43,31c0,6.77,4.76,12.1,12.4,12.1a11.69,11.69,0,0,0,8-2.91l-4-5a5.77,5.77,0,0,1-4,1.54c-2.8,0-5.34-2.11-5.34-5.77C205.54,27.62,207.45,25.11,210.83,25.11ZM111,20.63a9.69,9.69,0,0,0-6.32-1.9A11.86,11.86,0,0,0,92.57,31c0,7.17,4.94,12.1,12.36,12.1a8.41,8.41,0,0,0,5.65-1.81c0,2.29-2.54,3.44-5.78,3.44a16.25,16.25,0,0,1-6.45-1.37l-2.13,5.5a19.19,19.19,0,0,0,8.53,1.94c7.65,0,12.94-3.21,12.94-12V19.13H111Zm-5.74,16.15a5.54,5.54,0,0,1-5.56-5.86c0-3.3,2.09-5.89,5.56-5.89s5.56,2.59,5.56,5.89S108.75,36.78,105.24,36.78ZM132,18.87a6.51,6.51,0,0,0-4.8,1.76v-1.5H120V42.67h7.16V28c0-1.71.89-2.81,2.53-2.81s2.54,1.14,2.54,2.86V42.67h7.16V27.18C139.39,22.65,137.56,18.87,132,18.87Zm21,9c-.8-.22-1.87-.4-2.89-.62-1.33-.26-1.91-.75-1.91-1.63s.67-1.45,1.73-1.45c1.43,0,2.09.88,2.14,2.29h6.53c0-5.41-3.46-7.66-8.53-7.66-4.89,0-8.63,2.77-8.63,7.35a6.89,6.89,0,0,0,5.07,7.13,28.07,28.07,0,0,0,3.6.92c1.47.31,2,.75,2,1.72s-.85,1.45-2.05,1.45c-1.82,0-2.22-1.27-2.18-2.46H141c-.18,4.09,1.87,8,8.89,8,4.76,0,9.07-2.24,9.07-7.79C159,30.92,157.13,29,153,27.89ZM22.21,42.71h20.5V22.21H22.21ZM10.25,0a10.25,10.25,0,0,0,0,20.5h0a10.25,10.25,0,0,0,0-20.5Z"
              />
            </g>
          </g>
        </svg>
      </a>

      <div
        class="menu__search__container"
        :class="{ navopen: mainNavVisible == true }"
      >
        <div
          class="button__menu"
          :class="{ navopen: mainNavVisible == true }"
          @click="(mainNavVisible = !mainNavVisible), (showSearch = false)"
        >
          <svg xmlns="http://www.w3.org/2000/svg">
            <g
              class="menu_closed"
              data-name="Layer 2"
              :class="{ visible: mainNavVisible == false }"
            >
              <g>
                <rect
                  class="cls-1"
                  x="32.17"
                  y="32.19"
                  width="10.18"
                  height="10.2"
                />
                <path
                  class="cls-1"
                  d="M5.09,32.2H0V42.39A10.62,10.62,0,0,0,10.17,32.2H5.09Z"
                />
                <path
                  class="cls-1"
                  d="M42.36,0A10.63,10.63,0,0,0,32.18,10.2H42.36Z"
                />
                <path
                  class="cls-1"
                  d="M5.09,0a5.1,5.1,0,0,0,0,10.2h0A5.1,5.1,0,0,0,5.09,0Z"
                />
                <polygon
                  class="cls-1"
                  points="72.47 23.63 68.24 14.49 65.9 14.49 65.9 28.8 68.22 28.8 68.22 19.76 72.45 28.96 76.67 19.75 76.67 28.8 79.02 28.8 79.02 14.49 76.69 14.49 72.47 23.63"
                />
                <path
                  class="cls-1"
                  d="M86.24,18.71a4.9,4.9,0,0,0-4.94,5.17A5,5,0,0,0,86.41,29a4.93,4.93,0,0,0,4.3-2.33l-1.86-1.16a2.77,2.77,0,0,1-2.44,1.33,2.72,2.72,0,0,1-2.76-2H91a5,5,0,0,0,.1-1A4.85,4.85,0,0,0,86.24,18.71Zm-2.63,4.21a2.71,2.71,0,0,1,5.26,0Z"
                />
                <path
                  class="cls-1"
                  d="M98.08,18.71a3.81,3.81,0,0,0-2.61,1v-.75H93.26V28.8h2.23V23a2.14,2.14,0,1,1,4.28,0V28.8H102V22.65A3.81,3.81,0,0,0,98.08,18.71Z"
                />
                <path
                  class="cls-1"
                  d="M111.14,18.92v5.79A2.05,2.05,0,0,1,109,26.82a2,2,0,0,1-2.09-2.08V18.92h-2.24v6.24A3.89,3.89,0,0,0,111.16,28v.78h2.22V18.92Z"
                />
              </g>
            </g>

            <g class="menu_open" :class="{ visible: mainNavVisible == true }">
              <path
                d="M29 58C34.7357 58 40.3425 56.2992 45.1115 53.1126C49.8806 49.9261 53.5976 45.3969 55.7925 40.0978C57.9874 34.7988 58.5617 28.9678 57.4428 23.3424C56.3238 17.7169 53.5618 12.5496 49.5061 8.49392C45.4504 4.43819 40.2831 1.67621 34.6576 0.55724C29.0322 -0.561731 23.2012 0.0125647 17.9022 2.20751C12.6031 4.40245 8.07394 8.11945 4.88738 12.8885C1.70082 17.6575 0 23.2644 0 29C0 36.6913 3.05535 44.0676 8.4939 49.5061C13.9325 54.9447 21.3087 58 29 58Z"
                fill="#0A110F"
              />
              <path
                d="M22 34.252L27.0921 29.0673L22.0309 23.898L23.8671 22L28.9438 27.1693L34.0206 22L35.8568 23.898L30.7955 29.0673L35.8877 34.252L34.0514 36.15L28.9438 30.9498L23.8363 36.15L22 34.252Z"
                fill="#F45197"
              />
            </g>
          </svg>
        </div>
      </div>

      <transition name="fade">
        <nav class="nav-primary" v-if="mainNavVisible == true">
          <ul class="menu__parent">
            <div v-for="menu_item in menu" :key="menu_item['title']">
              <list-item :menu_item="menu_item" color="this.color"></list-item>
            </div>

            <div class="contact-block">
              <p
                class="contact-block_text"
                v-if="contact_text"
                v-html="contact_text"
              ></p>
              <a
                class="contact-block_phone"
                :href="'tel:' + contact_phone_number"
                v-html="contact_phone_label"
              ></a>
              <a
                class="contact-block_email"
                :href="'mailto:' + contact_email"
                v-html="contact_email"
              ></a>
              <p class="contact-block_address" v-html="contact_address"></p>
              <a
                class="contact-block_email"
                href="/contact/"
                v-html="'Subscribe to our newsletter'"
              ></a>
              <div class="contact-block_social">
                <a v-if="linkedin_url" :href="linkedin_url"
                  ><img :src="linkedin_icon" alt="Follow Signs Inc. on LinkedIn"
                /></a>
                <a v-if="facebook_url" :href="facebook_url"
                  ><img :src="facebook_icon" alt="Follow Signs Inc. on LinkedIn"
                /></a>
                <a v-if="instagram_url" :href="instagram_url"
                  ><img
                    :src="instagram_icon"
                    alt="Follow Signs Inc. on LinkedIn"
                /></a>
                <a v-if="mail_url" :href="'mailto:' + mail_url"
                  ><img :src="mail_icon" alt="Email Signs Inc."
                /></a>
              </div>
            </div>
            <div class="search-block">
              <p>Search</p>

              <div class="search-area">
                <input
                  class="search-input"
                  type="search"
                  placeholder=""
                  v-model="searchTerm"
                />
                <a
                  class="search-submit"
                  :href="searchTerm.length > 0 ? '/search/' + searchTerm : null"
                >
                  <img :src="search_icon" alt="search" />
                </a>
                <span class="notification">{{
                  searchTerm.length > 0
                    ? 'Search for ' + searchTerm + ' ...'
                    : 'Please enter a search term.'
                }}</span>
              </div>
            </div>
          </ul>
        </nav>
      </transition>
    </div>
  </header>
</template>

<script>
import axios from 'axios';
import ListItem from '../vue/ListItem.vue';
import searchIconPink from '../../images/Search_Pink.svg';

export default {
  data() {
    return {
      menu: null,
      mainNavVisible: false,
      mobNavVisible: false,
      showSearch: false,
      searchTerm: '',
      window: {
        width: 0,
        height: 0,
      },
      topScrollThreshold: 1,
      isScrolled: false,
      headerHeight: 150,
    };
  },

  props: {
    menu_icon: {},
    menu_icon_close: {},
    search_icon: {
      default: searchIconPink,
    },
    search_icon_close: {},
    logo: {},
    contact_link: {},
    contact_text: {},
    contact_phone_label: {},
    contact_phone_number: {},
    contact_email: {},
    contact_address: {},
    linkedin_icon: {},
    linkedin_url: {},
    facebook_icon: {},
    facebook_url: {},
    instagram_icon: {},
    instagram_url: {},
    mail_url: {},
    color: {},
  },

  computed: {},

  watch: {},

  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },

    didScroll() {
      this.isScrolled = window.scrollY > this.topScrollThreshold;
    },
  },

  components: {
    ListItem,
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.didScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.didScroll);
  },
  mounted() {
    axios
      .get('/wp-json/wp/v2/menu')
      .then(response => (this.menu = response.data));
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

header {
  position: fixed;
  top: 0;
  width: 100%;
  background: $signs-teal;
  z-index: 910;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 0;

  &.white {
    background: white;

    .container {
      .nav-primary {
        background: rgba(255, 255, 255, 0.95);
      }
    }

    .overlay {
      background: rgba(white, 1);

      .search-block {
        .search-input {
          border: 1px solid black;
          color: black;
        }
      }
    }
  }

  &.scrolled {
    .container {
      padding: 25px 0;

      .nav-primary {
        ul {
          @media (max-width: 1366px) {
            margin-top: 100px;
          }
        }
      }
    }
  }

  .overlay {
    z-index: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(black, 1);
    display: flex;
    flex-direction: column;
  }

  .container {
    grid-column: 2 / span 10;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding: 50px 0;
    transition: 0.2s ease all;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 115px;
    column-gap: 0;

    @media (max-width: 1366px) {
      grid-column: 2 / span 10;
      grid-template-columns: 1fr;
    }

    .menu__search__container {
      display: flex;
      flex-direction: row;
      align-items: center;
      grid-column: 10 / span 1;
      position: relative;
      transition: 0.2s ease all;
      transform: rotate(0deg);
      z-index: 9999;
      width: 115px;

      &.navopen {
        width: 55px;
      }

      div {
        &.button {
          &__menu {
            margin-right: 0;
            z-index: 1000;

            &:hover {
              cursor: pointer;
            }

            &.navopen {
              svg {
                width: 115px;

                @media (max-width: 1366px) {
                  height: 45px;
                  width: auto;
                }
              }
            }

            svg {
              height: 50px;
              fill: white;
              transition: 0.2s ease all;
              overflow: visible;
              width: 115px;

              @media (max-width: 1366px) {
                height: 45px;
                width: auto;
              }

              // 						0% {
              //   opacity: 0;
              //   transform: translateY(0);
              // }
              // 50% {
              //   opacity: 0.5;
              //   transform: translateY(-125px);
              // }
              // 100% {
              //   opacity: 1;
              //   transform: translateY(0px);
              // }

              g {
                &.menu_closed {
                  opacity: 0;
                  transform: translateY(-125px);
									transition: ease-in-out all;
									transition-duration: 0.2s;

                  &.visible {
                    opacity: 1;
                    transform: translateY(0);
										transition: ease-in-out all;
										transition-duration: 0.5s;
                  }
                }

                &.menu_open {
                  opacity: 0;
                  transform: translateY(-125px);
									transition: ease-in-out all;
									transition-duration: 0.2s;

                  &.visible {
                    opacity: 1;
                    transform: translateY(0);
										transition: ease-in-out all;
										transition-duration: 0.5s;
                  }
                }
              }

              path {
                height: 50px;

                @media (max-width: 1366px) {
                  height: 45px;
                  width: auto;
                }
              }

              &:hover {
                fill: $signs-pink;
                transition: 0.2s ease all;
              }
            }

            img {
              height: 50px;

              @media (max-width: 1366px) {
                height: 40px;
              }
            }
          }

          &__search {
            margin-right: 1rem;
            z-index: 1000;

            &:hover {
              cursor: pointer;
            }

            img {
              height: 50px;

              @media (max-width: 1366px) {
                height: 40px;
              }
            }
          }
        }
      }
    }

    .contact {
      grid-column: 2 / span 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 50px;

      @media (max-width: 1366px) {
        height: 40px;
      }
    }

    .site__logo {
      display: flex;
      flex-wrap: wrap;
      grid-column: 1 / span 1;

      svg {
        height: 50px;
        transition: 0.2s ease all;
        fill: white;

        @media (max-width: 1366px) {
          height: 30px;
        }

        &:hover {
          fill: $signs-pink;
          transition: 0.2s ease all;
        }
      }

      img {
        height: 50px;

        @media (max-width: 1366px) {
          height: 30px;
        }
      }
    }

    .nav-primary {
      position: fixed;
      z-index: 999;
      background: rgba($signs-teal, 0.95);
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      column-gap: 0;

      @media (max-width: 1366px) {
        overflow-y: scroll;
      }

      > ul {
        grid-column: 7 / span 6;
        list-style: none;
        display: flex;
        flex-direction: column;
        padding: 0;
        height: 100%;
        justify-content: center;
        transition: 0.2s ease all;

        @media (max-width: 1366px) {
          justify-content: flex-start;
          grid-column: 2 / span 10;
          margin-top: 140px;
        }
      }

      .button {
        &__menu {
          margin-right: 1rem;
          z-index: 1000;

          &:hover {
            cursor: pointer;
          }

          img {
            height: 50px;

            @media (max-width: 1366px) {
              height: 30px;
            }
          }
        }

        &__search {
          grid-column: 3 / span 1;
          margin-right: 1rem;
          z-index: 1000;

          &:hover {
            cursor: pointer;
          }

          img {
            height: 50px;

            @media (max-width: 1366px) {
              height: 30px;
            }
          }
        }
      }

      .contact-block {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        width: 100%;
        position: relative;
        margin-top: 50px;

        p {
          grid-column: 1 / span 6;
          color: white;
          font-size: 1.5rem;
          font-weight: bold;
          margin: 0 0 10px;
        }

        a {
          grid-column: 1 / span 6;
          color: white;
          font-size: 1.5rem;
          font-weight: bold;
          text-decoration: none;
          margin: 0 0 10px;

          &:hover {
            color: $signs-pink;
          }
        }

        &_text {
          color: $signs-pink !important;
        }

        &_social {
          list-style: none;
          padding: 0;
          margin: 0;
          display: inline-flex;
          margin-top: 10px;

          a {
            opacity: 1;
            transition: 0.2s ease all;
            margin-right: 1rem;

            &:hover {
              opacity: 0.75;
            }
            img {
              height: 20px;
            }
          }
        }
      }

      .search-block {
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-column: 7 / span 6;
        column-gap: 0;
        row-gap: 10px;
        width: 100%;
        position: relative;
        margin-top: 50px;

        @media (max-width: 1366px) {
          grid-column: 1 / span 12;
        }

        p {
          grid-column: 1 / span 6;
          color: white;
          font-size: 1.5rem;
          font-weight: bold;
          margin: 0;

          @media (max-width: 1366px) {
            grid-column: 1 / span 12;
          }
        }

        .search-area {
          grid-column: 1 / span 5;
          display: grid;
          grid-template-columns: 1fr 50px;

          @media (max-width: 1366px) {
            grid-column: 1 / span 12;
          }

          .search-input {
            grid-column: 1;
            border: 1px solid transparent;
            appearance: none;
            background: $signs-charcoal;
            font-size: 1rem;
            padding: 10px 20px;
            color: white;

            @media (max-width: 1366px) {
              grid-column: 1;
            }

            &:focus {
              outline: none;
            }

            &::-webkit-input-placeholder {
              color: white;
            }

            &:-ms-input-placeholder {
              color: white;
            }

            &::placeholder {
              color: white;
            }
          }

          .search-submit {
            grid-column: 2;
            text-align: center;
            background: $signs-charcoal;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            padding: 0 10px;

            @media (max-width: 1366px) {
              grid-column: 1;
            }

            @media (max-width: 1366px) {
              height: 4rem;
              grid-column: 2;
            }

            &:hover {
              opacity: 0.75;
              cursor: pointer;
            }
          }

          .notification {
            grid-column: 1 / span 6;
            color: lighten($signs-teal, 10);
            margin-top: 1rem;

            @media (max-width: 1366px) {
              grid-column: 1 / span 12;
            }
          }
        }
      }
    }
  }
}

.fade-enter-active {
  animation: fade-in 0.5s;
}

.fade-leave-active {
  animation: fade-in 0.2s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.fadespin-enter-active {
  animation: fade-spin 0.5s;
}

.fadespin-leave-active {
  animation: fade-spin 0.2s reverse;
}

@keyframes fade-spin {
  0% {
    opacity: 0;
    transform: translateY(0);
  }
  50% {
    opacity: 0.5;
    transform: translateY(-125px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteHeader.vue